import {
  EMPLOYEE_UPLOAD_REQUEST,
  EMPLOYEE_UPLOAD_SUCCESS,
  EMPLOYEE_UPLOAD_FAIL,
  EMPLOYEE_UPLOAD_RESET,
  EMPLOYEE_LIST_REQUEST,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_FAIL,
  EMPLOYEE_CREATE_REQUEST,
  EMPLOYEE_CREATE_SUCCESS,
  EMPLOYEE_CREATE_FAIL,
  EMPLOYEE_CREATE_RESET,
  EMPLOYEE_UPDATE_REQUEST,
  EMPLOYEE_UPDATE_SUCCESS,
  EMPLOYEE_UPDATE_FAIL,
  EMPLOYEE_UPDATE_RESET,
  EMPLOYEE_DELETE_REQUEST,
  EMPLOYEE_DELETE_SUCCESS,
  EMPLOYEE_DELETE_FAIL,
  EMPLOYEE_DELETE_RESET,
  EMPLOYEE_MARK_LEFT_REQUEST,
  EMPLOYEE_MARK_LEFT_SUCCESS,
  EMPLOYEE_MARK_LEFT_FAIL,
  EMPLOYEE_MARK_LEFT_RESET,
  EMPLOYEE_REJOIN_REQUEST,
  EMPLOYEE_REJOIN_SUCCESS,
  EMPLOYEE_REJOIN_FAIL,
  EMPLOYEE_REJOIN_RESET,
} from '../constants/employeeMasterConstants';

export const employeeUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_UPLOAD_REQUEST:
      return { loading: true };
    case EMPLOYEE_UPLOAD_SUCCESS:
      return { loading: false, success: true, uploadResult: action.payload };
    case EMPLOYEE_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeListReducer = (state = { employees: [], total: 0 }, action) => {
  switch (action.type) {
    case EMPLOYEE_LIST_REQUEST:
      return { ...state, loading: true };
    case EMPLOYEE_LIST_SUCCESS:
      return { loading: false, employees: action.payload.employees, total: action.payload.total, pages: action.payload.pages };
    case EMPLOYEE_LIST_FAIL:
      return { loading: false, error: action.payload, employees: [] };
    default:
      return state;
  }
};

export const employeeCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_CREATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_CREATE_SUCCESS:
      return { loading: false, success: true, employee: action.payload };
    case EMPLOYEE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_UPDATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_UPDATE_SUCCESS:
      return { loading: false, success: true, employee: action.payload };
    case EMPLOYEE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_DELETE_REQUEST:
      return { loading: true };
    case EMPLOYEE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeMarkLeftReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_MARK_LEFT_REQUEST:
      return { loading: true };
    case EMPLOYEE_MARK_LEFT_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_MARK_LEFT_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_MARK_LEFT_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeRejoinReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_REJOIN_REQUEST:
      return { loading: true };
    case EMPLOYEE_REJOIN_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_REJOIN_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_REJOIN_RESET:
      return {};
    default:
      return state;
  }
};
